import React, { useState, useCallback, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import News from './components/news/News';
import Bookmarks from './components/bookmarks/Bookmarks';
import ErrorBoundary from './components/ui/ErrorBoundary';
import { ThemeProvider } from './context/ThemeContext';
import { CATEGORIES } from './utils/api';
import './App.css';

/**
 * Root application component.
 * Manages search state, routing, and global providers.
 */
const App = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  /** Clear search when navigating to a different route. */
  useEffect(() => {
    setSearchQuery('');
  }, [location.pathname]);

  const handleSearch = useCallback((query) => {
    setSearchQuery(query);
  }, []);

  return (
    <ThemeProvider>
      <ErrorBoundary>
        <div className="qs-app">
          <Navbar onSearch={handleSearch} />

          <main className="qs-main">
            <Routes>
              {/* Home - latest news */}
              <Route path="/" element={<News key="home" mode="latest" searchQuery={searchQuery} />} />

              {/* Category routes */}
              {CATEGORIES.map((cat) => (
                <Route
                  key={cat.id}
                  path={`/${cat.id}`}
                  element={<News key={cat.id} mode="category" category={cat.id} searchQuery={searchQuery} />}
                />
              ))}

              {/* Bookmarks */}
              <Route path="/bookmarks" element={<Bookmarks />} />

              {/* 404 */}
              <Route path="*" element={
                <div className="container py-5 text-center">
                  <h1 className="qs-page-title">404</h1>
                  <p className="qs-muted">Page not found</p>
                </div>
              } />
            </Routes>
          </main>
        </div>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

App.propTypes = {};

App.displayName = 'App';

export default App;
